module.exports = __webpack_public_path__ + "fonts/euclid-square-300-italic.dda63396.ttf";